<template>
  <div>
    <custom-callout controlled :has-toggle="false">
      <div class="row">
        <div
          :class="
            `row d-flex align-items-center py-2 pr-3 ${
              checkable ? 'col-11' : 'col-12'
            }`
          "
        >
          <div class="col-12 col-md-4">
            <div class="data-name">Centro:</div>
            <div>
              {{ value.center?.name | empty }}
            </div>
          </div>

          <div class="col-12 col-md">
            <div class="data-name">Municipio:</div>
            <div>{{ value.municipality?.name | empty }}</div>
          </div>

          <div class="col-12 col-md">
            <div class="data-name">Lugar de Servicio:</div>
            <div>{{ value.location?.name | empty }}</div>
          </div>

          <div class="col-12 col-md-2 d-flex justify-content-end">
            <drop-down :items="actions" />
          </div>

          <div class="w-100 px-3">
            <hr />
          </div>

          <div class="col-12 col-md">
            <div class="data-name">Total de Servicios:</div>
            <div>{{ value.count | empty }}</div>
          </div>
        </div>
        <div
          v-if="checkable"
          class="col row align-items-center justify-content-center"
        >
          <div>
            <check-box v-model="value.checked" class="checkbox flex-grow-1" />
          </div>
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
//mixins
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//components
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';

import moment from 'moment';

export default {
  name: 'MedicaidClaimRowResult',
  components: {
    CustomCallout,
    DropDown,
  },
  filters: {
    time(value) {
      return value ? moment(value, 'HH:mm:ss').format('hh:mm A') : '-';
    },
  },
  mixins: [alertMixin],

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    checkable: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    actions() {
      return [
        {
          name: 'services',
          label: 'Ver Servicios',
          icon: 'fas fa-calendar text-green',
          click: () => {
            const payload = {
              center: this.value.center,
              location: this.value.location,
              locationType: this.value.locationType,
              municipality: this.value.municipality,
              isAdvancedSearch: true,
            };
            this.$emit('view-services', payload);
          },
        },
      ];
    },
  },
};
</script>

<style scoped>
.bg-green-gray {
  background-color: #ebf1ee !important;
}
</style>
